<template>
    <div class="reference-modal-wrap">
        <TitleBaseBox :title="title" noButton="true" @close="cancelClick" class="reference-modal-content">
            <component :is="componentName" :refercence="true" :isSingle="data.isSingle" @checkClick="checkHandler" @tabClick="tabClickHandler" />
            <div class="reference-modal-btn">
                <RoundButton class="cancel-btn" :text="cancelLabel" @btnClick="cancelClick"></RoundButton>
                <RoundButton
                    class="confirm-btn"
                    :class="{ 'confirm-disabled': isDisabled }"
                    :text="confirmLabel"
                    @btnClick="confirmClick"
                ></RoundButton>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import GuidesLibraryPage from "@/views/zhiji/pages/guides/GuidesLibraryPage";
import VideoLibraryPage from "@/views/zhiji/pages/video/VideoLibraryPage";
import PictureLibraryPage from "@/views/zhiji/pages/picture/PictureLibraryPage";
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";

export default {
    name: "ReferenceMaterialModal",
    props: ["data"],
    components: {
        GuidesLibraryPage,
        VideoLibraryPage,
        PictureLibraryPage,
        TitleBaseBox,
        RoundButton
    },
    data() {
        return {
            checkedData: {},
            componentName: "GuidesLibraryPage",
            isStorage: false,
            checkedDatas: [] // 批量引用视频攻略
        };
    },
    computed: {
        isDisabled() {
            return this.checkedData.id ? false : true;
        },
        title() {
            return this.calcTitleHandle();
        },
        cancelLabel() {
            return this.$t("zhiji.common.cancel");
        },
        confirmLabel() {
            return this.$t("zhiji.common.confirmLabel");
        }
    },
    methods: {
        calcTitleHandle() {
            let curTitle = this.$t("zhiji.answer.guideLibrary");
            if (this.data.type == "video" || this.data.type == "singleVideo") {
                curTitle = this.$t("zhiji.answer.videoLibrary");
                this.componentName = "VideoLibraryPage";
            } else if (this.data.type == "image") {
                curTitle = this.$t("zhiji.answer.pictureLibrary");
                this.componentName = "PictureLibraryPage";
            } else {
                curTitle = this.$t("zhiji.answer.guideLibrary");
                this.componentName = "GuidesLibraryPage";
            }
            return curTitle;
        },
        cancelClick() {
            this.$emit("closeModal");
        },
        confirmClick() {
            if (this.isStorage) {
                let handler = {
                    NotClassifyVideo: this.videoEdit,
                    NotClassifyStrategy: this.strategyEdit
                };
                handler[this.isStorage].call(null, this.checkedData);
            } else {
                this.data.confirm && this.data.confirm(this.checkedDatas);
                this.cancelClick();
            }
        },
        checkHandler(data) {
            if (data.checked && this.checkedDatas.indexOf(data.id) === -1) {
                if (this.data.isSingle) {
                    this.checkedDatas = [data];
                } else {
                    this.checkedDatas.push(data);
                }
            } else {
                const itemcheckedIdx = this.checkedDatas.forEach((item, idx) => {
                    if (item.id === data.id) {
                        return idx;
                    }
                    return -1;
                });
                itemcheckedIdx !== -1 && this.checkedDatas.splice(itemcheckedIdx, 1);
            }
            this.checkedData = this.checkedDatas[0] || {};
        },
        tabClickHandler(data) {
            if (data.componentName == "NotClassifyVideo" || data.componentName == "NotClassifyStrategy") {
                this.isStorage = data.componentName;
            } else {
                this.isStorage = false;
            }
            this.checkedData = {};
        },
        strategyEdit(data) {
            const sourceObj = {
                tgl: "queryTglStrategy",
                gicp: "queryGicpStrategy"
            };
            this.zhiji
                .requestByServiceName(sourceObj[data.sourceType], {
                    tipId: data.id
                })
                .then(result => {
                    this.$store.dispatch("showModal", {
                        type: "TextGuidesEditModel",
                        data: {
                            type: "edit",
                            sourceType: data.sourceType,
                            strategyData: result.strategyData[0],
                            childModel: true,
                            confirm: ret => {
                                this.data.confirm && this.data.confirm(ret);
                                this.cancelClick();
                            }
                        }
                    });
                });
        },
        videoEdit(data) {
            const sourceObj = {
                gicp: "queryGicpVideoList"
            };
            this.zhiji
                .requestByServiceName(sourceObj[data.sourceType], {
                    videoId: data.id
                })
                .then(result => {
                    this.$store.dispatch("showModal", {
                        type: "VideoEditModel",
                        data: {
                            type: "gicpEdit",
                            videoData: result.gicpVideoData[0],
                            childModel: true,
                            confirm: ret => {
                                this.data.confirm && this.data.confirm(ret);
                                this.cancelClick();
                            }
                        }
                    });
                });
        }
    }
};
</script>

<style lang="less">
.reference-modal-wrap {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    .reference-modal-content {
        height: 738px;
        font-size: 12px;
        overflow: hidden;
        box-sizing: border-box;

        .base-content {
            padding: 0 !important;
            height: calc(100% - 38px);
            box-sizing: border-box;
            overflow-y: auto;
            .strategy-material-wrap,
            .video-library-wrapper,
            .picture-library-wrapper {
                padding-top: 0;
                height: calc(100% - 73px);
            }
        }

        .reference-modal-btn {
            display: flex;
            justify-content: flex-end;
            box-sizing: border-box;
            padding: 20px;
            background: #fafbfd;
            border-top: 1px solid #d8e4f0;

            .cancel-btn {
                margin-right: 10px;
            }
            .confirm-disabled {
                background-color: #c9c9c9 !important;
            }
        }
    }

    @media screen and (max-width: 1440px) {
        .reference-modal-content {
            width: 1077px;
        }
    }

    @media screen and (min-width: 1440px) {
        .reference-modal-content {
            width: 1335px;
        }
    }
}
</style>
